import { FloorplanResponse } from '@domain/floorplan';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export interface admissionFloorplan {
  floorplanId: string;
  admissions: string[];
}

const addAdmission = async ({ floorplanId, admissions }: admissionFloorplan) => {
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/floorplan-presets/${floorplanId}`;

  return request({
    url,
    method: RequestMethod.PATCH,
    body: { 'admission-presets': admissions },
  });
};

export const useAddAdmissionFloorplanPreset = (floorplanId: string) => {
  return useGenericMutation<FloorplanResponse, RequestError, string[]>(
    [QUERY_KEYS.addAdmissionFloorplanPreset, floorplanId],
    async (admissions: string[]) => addAdmission({ floorplanId, admissions })
  );
};
